import { render, staticRenderFns } from "./ProductEditMedia.vue?vue&type=template&id=4044d2a7&"
import script from "./ProductEditMedia.vue?vue&type=script&lang=js&"
export * from "./ProductEditMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports